import React from "react";

export const CabinetProspectionsAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: "/cabinet/prospections/liste",
      component: React.lazy(() => import("./CabinetProspectionsApp")),
    },
  ],
};
